import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from 'partials/button.module.scss';

export const Button = forwardRef((props, ref) => {
	const {
		className,
		disabled,
		onClick,
		disabledClassName,
		title,
		ariaLabel,
		type
	} = props;

	const handleButtonClick = (event) => {
		if (disabled) return;
		onClick &&
			onClick({
				event
			});
	};

	const renderChildren = () => {
		const { label, children } = props;

		if (label) {
			return label;
		}
		if (children) {
			return children;
		}
		return 'Button';
	};

	const _className = cx(className, styles.btn, {
		[disabledClassName]: disabledClassName
	});

	return (
		<button
			type={type}
			ref={ref}
			onClick={handleButtonClick}
			className={_className}
			aria-label={ariaLabel}
			disabled={disabled}
			title={title}>
			{renderChildren()}
		</button>
	);
});

Button.propTypes = {
	onClick: PropTypes.func,
	children: PropTypes.node,
	className: PropTypes.string,
	label: PropTypes.string,
	disabledClassName: PropTypes.string,
	ariaLabel: PropTypes.string,
	title: PropTypes.string,
	disabled: PropTypes.bool,
	type: PropTypes.string
};

Button.defaultProps = {
	className: '',
	label: '',
	ariaLabel: '',
	disabled: false,
	disabledClassName: '',
	title: '',
	type: 'button'
};
